

export default function header() {

    const $window = $(window);
    const $body = $('body');
    const scrollThreshold = 200;
    let menu_overflow_timer;

    const setHeaderScrolled = (scrolled) => {
        scrolled ? $body.addClass('header-scrolled') : $body.removeClass('header-scrolled');
    };

    const setHeaderState = () => {
        let scrollTop = $window.scrollTop();
        if (scrollTop > scrollThreshold) {
            setHeaderScrolled(true);
        } else {
            setHeaderScrolled(false);
        }
    };

    $window.on('scroll', () => setHeaderState());

    $window.on('load', () => setHeaderState());


    $('.header-menu-toggle').on('click', function (e) {
        e.preventDefault();
        clearTimeout(menu_overflow_timer);
        if ($body.hasClass('stop-scroll')) {
            menu_overflow_timer = setTimeout(() => {
                $body.removeClass('stop-scroll');
            }, 400);
        } else {
            menu_overflow_timer = setTimeout(() => {
                $body.addClass('stop-scroll');
            }, 400);
        }

        $body.toggleClass('full-screen-menu-open');
        $('.header-menu-toggle.hamburger').toggleClass('is-active');
    });

    $('.toggle-search').on('click', function (e) {
        e.preventDefault();
        const $input = $('.header-search').find('input[type=search]');
        $body.toggleClass('search-open');
        if ($body.hasClass('search-open')) {
            setTimeout(() => ($input.focus()), 300);
        } else {
            setTimeout(() => ($input.val('')), 300);
        }
    });

}
